import { injectable, inject } from 'inversify';
import { ok, err } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'

type QuestionDataType = 'state' | 'answer'

@injectable()
export class QuestionStateSerializer {

  constructor(
    @inject(SerializationApi.TypedStateSerializerSymbol)
    private serializer: SerializationApi.TypedStateSerializer) {
  }

  serialize<T>(type: string, dataType: QuestionDataType, state: T, format: string) {
    const name = this.serializerName(type, dataType)
    const serializationResult = this.serializer.serialize(name, format, state)
    return serializationResult
    // if (serializationResult.success) {
    //   return ok(serializationResult.value)
    // }

    // return err(serializationResult.error)
  }

  deserialize<T>(typeOrId: string | number, dataType: QuestionDataType, buffer: Uint8Array, format: string) {

    let nameOrId
    if (typeof typeOrId === 'string') {
      nameOrId = this.serializerName(typeOrId, dataType)
    } else {
      nameOrId = typeOrId
    }
    const deserializationResult = this.serializer.deserialize<T>(nameOrId, format, buffer)
    if (deserializationResult.success) {
      return ok(deserializationResult.value.content)
    }

    return err(deserializationResult.error)
  }

  private serializerName(type: string, dataType: QuestionDataType) {
      return SerializationApi.stateSerializerName('suspend-data', `question-${dataType}-${type}`)
  }
}
